import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'react-emotion';

import Rating from '~/modules/ecommerceCoreUI/components/basic/Rating';
import { SmallSpacer } from '~/modules/coreUI/components/legacies/Spacers';
import { SmallLabel } from '~/modules/coreUI/components/legacies/Labels';

const RatingWithLabelWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: ${props => props.theme.paddings.medium}px ${props => props.theme.paddings.normal}px;
  background: ${props => (props.selected ? '#f9f9f9' : '')};
  cursor: pointer;
`;

const ratingValuesMapper = {
  four_stars: { label: '4+', value: 4.5 },
  three_stars: { label: '3+', value: 3.5 },
  two_stars: { label: '2+', value: 2.5 },
  one_star: { label: '1+', value: 1.5 },
};

class RatingFilterWrapper extends Component {
  onSelectRating = filterOption => this.props.onSelectRating(filterOption);

  render() {
    const { listOfOptions } = this.props;

    return (
      <React.Fragment>
        {listOfOptions.map(filterOption => (
          <React.Fragment key={filterOption.name}>
            <RatingWithLabelWrapper
              selected={filterOption.selected}
              onClick={() => this.onSelectRating(filterOption)}
            >
              <SmallLabel htmlFor={filterOption.name}>
                {ratingValuesMapper[filterOption.value].label}
              </SmallLabel>
              <SmallSpacer />
              <Rating
                name={filterOption.name}
                rating={ratingValuesMapper[filterOption.value].value}
              />
            </RatingWithLabelWrapper>
          </React.Fragment>
        ))}
      </React.Fragment>
    );
  }
}

RatingFilterWrapper.propTypes = {
  listOfOptions: PropTypes.instanceOf(Array).isRequired,
  onSelectRating: PropTypes.func.isRequired,
};

export default RatingFilterWrapper;
